<template>
  
    <div>
      <div v-if="isEaf">
        <!--<div>
          <span v-for="(ch, index) in chunks" :key="ch.id" :id="ch.id" class="chunkText">
            <Chunkword v-for="word in ch.chunkwords" :key="word.id" :chunk="ch" :index="index" :word="word" :filter="filter"/>
            <span style="width:4px;display:inline-block;">&nbsp;</span>
          </span>
        </div>-->

        <div>
          <b-link v-if="prevButton" class="colorBlue" @click="getChunk(-1)">❮••</b-link>
          
          <span v-for="(ch, index) in chunks" :key="ch.id" :id="ch.id" class="chunkText udm-font">
            <Chunkword v-for="word in ch.translate.chunkwords" :key="word.id" :chunk="ch" :index="index" :word="word" :filter="filter"/>
            <span style="width:4px;display:inline-block;">&nbsp;</span>
          </span>

          <b-link v-if="nextButton" class="colorBlue" @click="getChunk(1)">••❯</b-link>
        </div>

        <div v-if="chunks.length>0 && chunks[0] && chunks[0].translate.translate" class="translate mt-2">
          <span v-for="ch of chunks" :key="ch.id" :id="ch.id" class="chunkText">
            {{ ch.translate.translate.body }}
            <span style="width:4px;display:inline-block;">&nbsp;</span>
          </span>
        </div>
      </div>

      <div v-else>
        <b-link v-if="prevButton" class="colorBlue" @click="getChunk(-1)">❮••</b-link>

        <span v-for="(ch, index) of chunks" :key="ch.id" :id="ch.id" class="chunkText">
            <Chunkword v-for="word in ch.chunkwords" :key="word.id" :chunk="ch" :index="index" :word="word" :filter="filter"/>
            <span style="width:4px;display:inline-block;">&nbsp;</span>
        </span>

        <b-link v-if="nextButton" class="colorBlue" @click="getChunk(1)">••❯</b-link>
      </div>

    </div>

</template>

<script>
import ChunkContent from './ChunkContent'
import Chunkword from './Chunkword'
export default {
  name: "ChunkContent",
  components:{
    ChunkContent,
    Chunkword
  },
  props: {
      chunks: {
          type: Array,
          default: []
      },
      filter: {
          type: Object,
          default: null
      },
      prevButton: {
        type: Boolean,
        default: false
      },
      nextButton: {
        type: Boolean,
        default: false
      },
      isEaf: {
        type: Boolean,
        default: false
      }
  },
  data(){
    return {

    }
  },

  mounted() {

  },

  methods: {
    getChunk(mode){
      this.$emit('getChunk',mode)
    }
  }
}
</script>

<style @scoped>
  .colorBlue {color:mediumblue;}
  .colorBlue:hover {color:red;text-decoration: none;}
  .translate {color: grey;font-size:12px;}
</style>